var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8894 8.17936L11.9993 14.5553L5.10916 8.17936C4.98605 8.06521 4.8208 8.00131 4.64871 8.00131C4.47663 8.00131 4.31137 8.06521 4.18827 8.17936C4.12866 8.2348 4.08131 8.30098 4.04898 8.37401C4.01665 8.44704 4 8.52546 4 8.60468C4 8.6839 4.01665 8.76232 4.04898 8.83536C4.08131 8.90839 4.12866 8.97456 4.18827 9.03L11.5182 15.8142C11.6469 15.9333 11.8195 16 11.9993 16C12.1791 16 12.3517 15.9333 12.4804 15.8142L19.8103 9.03131C19.8703 8.97583 19.9181 8.90949 19.9506 8.83622C19.9832 8.76294 20 8.68422 20 8.60468C20 8.52515 19.9832 8.44642 19.9506 8.37314C19.9181 8.29987 19.8703 8.23353 19.8103 8.17805C19.6872 8.0639 19.522 8 19.3499 8C19.1778 8 19.0125 8.0639 18.8894 8.17805V8.17936Z",
    fill: "#23222F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.40ec2af46b277b414f8330a36564b8bc.svg";
export { ForwardRef as ReactComponent };